import React from 'react';
import { Redirect, Route, useLocation, RouteProps } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import AuthLayout from '../../components/Layout/AuthLayout';
import { PermMode } from '../../components/WithPermission';
import { PendingChangesContextProvider } from '../../context/PendingChangesContext';
import BasicLayout from '../../components/Layout/BasicLayout';

type Props = {
  requiredPerms?: string | string[];
  permsMode?: PermMode;
  unauthenticated?: boolean;
} & RouteProps;

export const CHECKING_PERMISSIONS_PATH: string = '/checking-permissions';

export const AuthenticatedRoute = ({
  children,
  unauthenticated,
  requiredPerms,
  permsMode = PermMode.ALL,
  ...rest
}: Props) => {
  const location = useLocation();
  const { authState, checkPerm, authorizationPermissions } = useAuth();
  const withBaseNav: string[] = ['/welcome-email-instruction'];

  if (authState.isAuthenticated && unauthenticated) {
    return <Redirect to={CHECKING_PERMISSIONS_PATH} />;
  }

  if (!authState.isAuthenticated && !unauthenticated) {
    if (withBaseNav.includes(location.pathname)) {
      return <Route {...rest} render={() => <BasicLayout showUnauthenticatedNav>{children}</BasicLayout>} />;
    }
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location.pathname }
        }}
      />
    );
  }

  if (
    authState.isAuthenticated &&
    requiredPerms &&
    Object.entries(authorizationPermissions).length &&
    !checkPerm(requiredPerms, permsMode)
  ) {
    return <Redirect to={CHECKING_PERMISSIONS_PATH} />;
  }

  return (
    (
      <Route
        {...rest}
        render={() => (
          <PendingChangesContextProvider>
            <AuthLayout>{children}</AuthLayout>
          </PendingChangesContextProvider>
        )}
      />
    ) ?? null
  );
};
